import { Center, Flex, Icon, Text } from '@chakra-ui/react'
import { Invalid } from '../../../utils/constants/icons'

const InvalidInput = ({
  isError,
  label,
  override,
  color,
  fontWeight,
}: {
  isError: boolean
  label: string
  override?: string
  color?: string
  fontWeight?: string
}) => {
  return (
    <>
      {isError && (
        <Flex pt="4px">
          <Center>
            <Icon mr="8px" w="16px" h="16px" viewBox="0 0 20 20" fill="white">
              <Invalid />
            </Icon>
          </Center>
          <Center>
            <Text color={color ?? '#FF4F28'} textStyle="b-sm" fontWeight={fontWeight ?? '510'}>
              {override ? override : `It looks like that isn't a valid ${label}`}
            </Text>
          </Center>
        </Flex>
      )}
    </>
  )
}

export default InvalidInput
